import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";

library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { getData } = useContext(Context);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const GetEditData = async () => {
    const response = await getData(`/admin/broker/plan/${id}`);

    if (response?.success) {
      reset({
        name: response?.data?.name || "",
        amount: response?.data?.amount || "",
        validity_days: response?.data?.validity_days || "",
      });
    }
  };

  useEffect(() => {
    if (id) {
      GetEditData();
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();

      finalData.append("name", data?.name);
      finalData.append("amount", data?.amount);
      finalData.append("validity_days", data?.validity_days);

      const response = await putData(`/admin/broker/plan/${id}`, finalData);

      if (response?.success) {
        await setShowModal({
          code: response.code,
          message: response?.data,
        });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.errors,
        });
      }

      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Partner Subscription Plan
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              {/* Plan Name */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div>
                      <Form.Label>Name</Form.Label>
                    </div>

                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Plan Name"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Plan Name is required",
                          validate: (value) =>
                            value.trim().length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>

                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* Amount */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div>
                      <Form.Label>Amount</Form.Label>
                    </div>

                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="amount"
                        placeholder="Enter Amount"
                        maxLength={10}
                        className={classNames("", {
                          "is-invalid": errors?.amount,
                        })}
                        {...register("amount", {
                          required: "Amount is required",
                          maxLength: {
                            value: 10,
                            message: "Amount cannot exceed 10 characters",
                          },
                          validate: (value) =>
                            Number(value) > 0 ||
                            "Amount must be greater than 0",
                        })}
                        onKeyDown={(e) => {
                          if (
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            e.key === "Backspace" ||
                            e.key === "Delete" ||
                            e.key === "Tab"
                          ) {
                            return;
                          }

                          if (!/[\d.]/.test(e.key)) {
                            e.preventDefault();
                          }

                          if (e.key === "." && e.target.value.includes(".")) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </InputGroup>

                    {errors.amount && (
                      <span className="text-danger">
                        {errors.amount.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* Validity Days */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div>
                      <Form.Label>Validity Days</Form.Label>
                    </div>

                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="validity_days"
                        placeholder="Enter Validity Days"
                        maxLength={5}
                        className={classNames("", {
                          "is-invalid": errors?.validity_days,
                        })}
                        {...register("validity_days", {
                          required: "Validity Days is required",
                          maxLength: {
                            value: 5,
                            message: "Validity Days cannot exceed 5 characters",
                          },
                          validate: (value) =>
                            Number(value) > 0 ||
                            "Validity Days must be greater than 0",
                        })}
                        onKeyDown={(e) => {
                          if (
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            e.key === "Backspace" ||
                            e.key === "Delete" ||
                            e.key === "Tab"
                          ) {
                            return;
                          }

                          if (!/[\d]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </InputGroup>

                    {errors.validity_days && (
                      <span className="text-danger">
                        {errors.validity_days.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
